// AWS Configuration - Auto-generated from CloudFormation outputs
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

const awsConfig = {
  Auth: {
    Cognito: {
      // Amazon Cognito User Pool ID
      userPoolId: 'us-east-1_yvva2yfuB',
      // Amazon Cognito Web Client ID
      userPoolClientId: 'ts73mhsfj0bq516fqaijr4kl1',
      // Amazon Cognito Region
      region: 'us-east-1',
			identityPoolId: 'us-east-1:a74e082d-f803-493e-9e41-8599ec6bb6af',
    }
  },
  Storage: {
    S3: {
      // Amazon S3 bucket name
      bucket: 'rangedat.chrispollard.dev-uploads',
      // Amazon S3 region
      region: 'us-east-1',
      // Use authenticated identity pool
      identityPoolId: 'us-east-1:a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6',
      // Use user credentials to access S3
      useAccelerateEndpoint: false,
      // Configure to use authentication tokens
      credentialsProvider: 'cognito'
    }
  }
};

// Initialize AWS Amplify
Amplify.configure(awsConfig);

// Configure token provider for local storage
cognitoUserPoolsTokenProvider.setKeyValueStorage({
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
});

// Export the configured token provider for use in components
export { cognitoUserPoolsTokenProvider as tokenProvider };

export default awsConfig;
